import { NgModule, isDevMode } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { EnvironmentBase, WeekNumberPipe } from '@definitiv-packages/angular-dba-library';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StartViewComponent } from './views/start-view/start-view.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { environment } from '../environments/environment';
import { DatenschutzViewComponent } from './views/datenschutz-view/datenschutz-view.component';
import { AGBViewComponent } from './views/agb-view/agb-view.component';
import { ImpressumViewComponent } from './views/impressum-view/impressum-view.component';
import { LibraryModule, ProjectEnvironment } from '../../../roofsafetymanagement-library/src/public-api';
import { DebitorMainViewComponent } from './views/debitor-main-view/debitor-main-view.component';
import { ObjektMainViewComponent } from './views/objekt-main-view/objekt-main-view.component';
import { CreateDebitorComponent } from './dialogs/create-debitor/create-debitor.component';
import { RoofareaMainViewComponent } from './views/roofarea-main-view/roofarea-main-view.component';
import { VerwaltungMainViewComponent } from './views/verwaltung-main-view/verwaltung-main-view.component';
import { UserMainViewComponent } from './views/user-main-view/user-main-view.component';
import { GroupMainViewComponent } from './views/group-main-view/group-main-view.component';
import { SafetyPointMainViewComponent } from './views/safetypoint-main-view/safetypoint-main-view.component';
import { CalendarViewComponent } from './views/calendar-view/calendar-view.component';
import { CustomMonthView } from './components/custom-month-view/custom-month-view.component';
import { ServiceMainViewComponent } from './views/service-main-view/service-main-view.component';
import { CreateServiceComponent } from './dialogs/create-service/create-service.component';
import { CloseServiceComponent } from './dialogs/close-service/close-service.component';
import { CreateSafetyPointFormDialogComponent } from './dialogs/create-safetypointform-dialog/create-safetypointform-dialog.component';
import { SafetyPointFormComponent } from './dialogs/safetypointform-dialog/safetypointform-dialog.component';
import { UuidViewComponent } from './views/uuid-view/uuid-view.component';
import { TodosViewComponent } from './views/todos-view/todos-view.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { StandortMainViewComponent } from './views/standort-main-view/standort-main-view.component';
import { SicherungssystemMainViewComponent } from './views/sicherungssystem-main-view/sicherungssystem-main-view.component';


@NgModule({
  declarations: [
    AppComponent,
    SidenavComponent,
    CustomMonthView,
    UuidViewComponent,
    CalendarViewComponent,
    StartViewComponent,
    DatenschutzViewComponent,
    AGBViewComponent,
    ImpressumViewComponent,
    DebitorMainViewComponent,
    ObjektMainViewComponent,
    RoofareaMainViewComponent,
    SafetyPointMainViewComponent,
    ServiceMainViewComponent,
    VerwaltungMainViewComponent,
    UserMainViewComponent,
    GroupMainViewComponent,
    CreateDebitorComponent,
    CreateServiceComponent,
    CloseServiceComponent,
    CreateSafetyPointFormDialogComponent,
    SafetyPointFormComponent,
    TodosViewComponent,
    StandortMainViewComponent,
    SicherungssystemMainViewComponent
  ],
  imports: [
    BrowserModule,
    WeekNumberPipe,
    GoogleMapsModule,
    BrowserAnimationsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    AppRoutingModule,
    LibraryModule,
    FormsModule,
    DragDropModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    { provide: EnvironmentBase, useValue: environment },
    { provide: ProjectEnvironment, useValue: environment },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
